import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { formattedWeight } from "@jti/fe-common";
import { useTranslations } from "@jti/ui";
import { Typography } from "@jti/ui-library";
const ProductSpecificationElement = ({ label, value }) => {
    const { __ } = useTranslations();
    if (!value) {
        return _jsx(React.Fragment, {});
    }
    const formattedValue = label.toLowerCase() === "weight" ? formattedWeight(value) : value;
    return (_jsx("div", { className: "product-specification", children: _jsxs("div", { className: "product-specification__element", children: [_jsx("div", { className: "product-specification__element-side", children: _jsx(Typography, { weight: "bold", variant: "small-title", mobileVariant: "text", children: __(`productspecification.attribute.${label}`) }) }), _jsx("div", { className: "product-specification__element-side product-specification__element-side--right", children: _jsx(Typography, { variant: "subtitle", mobileVariant: "text", children: formattedValue }) })] }) }));
};
export default ProductSpecificationElement;
//# sourceMappingURL=ProductSpecificationElement.js.map